<template>
  <b-modal id="updateAgreementDeviceModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmagreementdevice.updateAgreementDeviceHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="agreementDevice">
      <b-col>
        <!--<EXCMAgreementDeviceUpdate :agreementDeviceId="getIdLink(agreementDevice['@id'])"></EXCMAgreementDeviceUpdate>-->
        <EXCMAgreementDeviceUpdate :agreementDeviceId="agreementDevice['@id']"></EXCMAgreementDeviceUpdate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMAgreementDeviceUpdate from '../Update.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'UpdateAgreementDeviceModal',
  components: {
    EXCMAgreementDeviceUpdate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmagreementdevice.update.show
    },
    devicePivot () {
      return this.$store.state.modals.excmagreementdevice.update.devicePivot
    },
    close () {
      return this.$store.state.modals.excmagreementdevice.update.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'devicePivot': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      agreementDevice: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.devicePivot) {
        this.agreementDevice = Object.assign({}, this.devicePivot)
        this.$store.state.modals.excmagreementdevice.update.show = 0
        this.$store.state.modals.excmagreementdevice.update.devicePivot = null
        this.$bvModal.show('updateAgreementDeviceModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmagreementdevice.update.close = 0
        this.$bvModal.hide('updateAgreementDeviceModal')
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
